import styles from './styles.module.scss'

const ClosingSection = (): JSX.Element => (
  <section className={`${styles.block} ${styles.closing}`}>
    <div className={`${styles.content} ${styles.center}`}>
      <h2>みんなで、荷物に困らない街をつくろう</h2>
      <p>
        あなたの紹介が、旅行者の1日をもっと自由にします。あなたの街に、荷物を預けられる場所を増やしましょう。
      </p>
      <div className={styles.heroCta}>
        <a
          href="#form"
          className={`${styles.button} ${styles.primaryButton} ${styles.largeButton}`}
        >
          紹介者登録をする
        </a>
      </div>
      <p className={styles.closingNote}>
        ※ 本キャンペーンは予告なく終了、または内容を変更する場合があります。
      </p>
    </div>
  </section>
)

export default ClosingSection
